export function useIsGoogleBot() {
    if (import.meta.server) {
        const event = useRequestEvent();
        return event && event.context && event.context.isGoogleBot === true;
    }
    return false;
};